import { render, staticRenderFns } from "./payment-success.vue?vue&type=template&id=496162ca&scoped=true&"
import script from "./payment-success.vue?vue&type=script&lang=js&"
export * from "./payment-success.vue?vue&type=script&lang=js&"
import style0 from "./payment-success.vue?vue&type=style&index=0&id=496162ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "496162ca",
  null
  
)

export default component.exports